import store from "@/store";

// export enum Color {
//   BLACK,
//   WHITE,
// }
//
// interface Loader {
//   color?: Color;
//   opacity?: number;
//   text?: string;
// }

class CoreLoader {
  element;
  textElement;
  visible = false;

  constructor() {
    const style = document.createElement('style');
    style.innerText = '.scc-loader{transition:.1s ease opacity,.1s ease transform;display:none;position:fixed;width:100%;height:100%;z-index:9999;top:0;left:0;background:radial-gradient(rgba(20,20,20,.4),rgba(0,0,0,.4));background:-webkit-radial-gradient(rgba(20,20,20,.4),rgba(0,0,0,.4))}.scc-loader-wrap{display:table;width:100%;height:100%;color:#cbcbcb}.scc-loader-content{display:table-cell;vertical-align:middle;text-align:center}.scc-loader-icon{margin:0 auto;width:50px;height:50px;border:solid 3px transparent;border-top-color:#29d;border-left-color:#29d;border-radius:50%;-webkit-animation:scc-loader-spinner 1s linear infinite;-moz-animation:scc-loader-spinner 1s linear infinite;-ms-animation:scc-loader-spinner 1s linear infinite;-o-animation:scc-loader-spinner 1s linear infinite;animation:scc-loader-spinner 1s linear infinite}.scc-loader-text{margin-top:20px;font-weight:600}@-webkit-keyframes scc-loader-spinner{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@-moz-keyframes scc-loader-spinner{0%{-moz-transform:rotate(0);transform:rotate(0)}100%{-moz-transform:rotate(360deg);transform:rotate(360deg)}}@-o-keyframes scc-loader-spinner{0%{-o-transform:rotate(0);transform:rotate(0)}100%{-o-transform:rotate(360deg);transform:rotate(360deg)}}@-ms-keyframes scc-loader-spinner{0%{-ms-transform:rotate(0);transform:rotate(0)}100%{-ms-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes scc-loader-spinner{0%{transform:rotate(0);transform:rotate(0)}100%{transform:rotate(360deg);transform:rotate(360deg)}}';
    document.head.appendChild(style);

    this.element = document.createElement('div');
    this.element.classList.add('scc-loader');
    this.element.innerHTML = '<div class="scc-loader-wrap"> <div class="scc-loader-content"> <div class="scc-loader-icon"></div><div class="scc-loader-text">Loading...</div></div></div>';
    document.body.insertBefore(this.element, document.body.firstChild);
    this.textElement = this.element.querySelector(".scc-loader-text");
  }

  show(msg) {
    if (msg == null) msg = "";
    this.textElement.innerHTML = msg;
    if (!this.visible) {
      this.element.style.opacity = 1;
      this.element.style.display = 'block';
    }
    this.visible = true;
    // if (params == null) params = { color: Color.BLACK, opacity: 0.5 };
    // if (params.color == null) params.color = Color.BLACK;
    // if (params.opacity == null) params.opacity = 0.5;
    //
    // let color = null;
    //
    // if (params.color === Color.BLACK) {
    //   color = "#000000";
    // } else if (params.color === Color.WHITE) {
    //   color = "#ffffff";
    // }
    //
    // store.dispatch("loader", {
    //   visible: true,
    //   opacity: params.opacity,
    //   color: color,
    //   text: params.text,
    // });
  }

  hide() {
    if (this.visible) {
      const el = this.element;
      el.style.opacity = 0;
      window.setTimeout(function () {
        el.style.display = 'none';
      }, 100);
    }
    this.visible = false;
  }
}

export default new CoreLoader();
